<script setup>
import TheApplicationPayment1 from "@/components/Admin/TheApplicationPayment1";
import TheApplicationPayment2 from "@/components/Admin/TheApplicationPayment2";
import {computed} from 'vue'
import {useStore} from "vuex";
const store = useStore()
const user = computed( () => {return store.getters['authModule/user']})
const activeComponent = computed( () => {
  // после выхода user отсутствует
  // возвращает: ипотека - 1, рассрочка - 2
  if (user.value !== null) {
    return Number(user.value.type) === 1;
  } else {
    return false
  }
})
</script>
<template>
  <component :is="activeComponent ? TheApplicationPayment1 : TheApplicationPayment2"></component>
</template>